module.exports = __webpack_public_path__ + "static/media/blogpost2.461bf82a.jpg";